<div class="sidebar-layout-container">
  <!-- Two Column Layout -->
  <div class="sidebar-layout-content">
    <!-- Left Menu Column -->
    <div class="sidebar-menu">
      <div class="menu-items">
        @for (item of menuItems; track item.id) {
          <button class="menu-item" [class.active]="activeItemId === item.id" (click)="selectItem(item)">
            @if (item.icon) {
              <img [src]="item.icon" alt="{{ item.label }}" class="menu-icon" />
            }
            <span>{{ item.label }}</span>
          </button>
        }
      </div>
    </div>

    <!-- Right Content Column -->
    <div class="sidebar-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
